/**
 * Number.prototype.format(n, x, s, c)
 * 
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
Number.prototype.format = function(n, x, s, c) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
        num = this.toFixed(Math.max(0, ~~n));

    return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};

String.prototype.moneyBR = function() {
    return parseFloat(this).format(2, 3, '.', ',');
};

String.prototype.ucfirst = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

String.prototype.dateDB = function() {
    var d = this.split('/');
    return d[2] + '-' + d[1] + '-' + d[0];
};

String.prototype.dateBR = function() {
    var t = this.split('-');
    return t[2] + '/' + t[1] + '/' + t[0];
};

String.prototype.toDate = function() {
    /* Espera data no formato YYYY-mm-dd */
    var d = this.split('-');
    return new Date(parseInt(d[0]), parseInt(d[1]) - 1, parseInt(d[2]));
};

Date.prototype.date_format = function(format) {
    var date =
        this.getFullYear() +
        '-' +
        to2ndBase(this.getMonth() + 1) +
        '-' +
        to2ndBase(this.getDate()) +
        ' ' +
        to2ndBase(this.getHours()) +
        ':' +
        to2ndBase(this.getMinutes()) +
        ':' +
        to2ndBase(this.getSeconds());

    var date = date.split(' ');
    var d = date[0].split('-');
    format = format.replace('%Y', d[0]);
    format = format.replace('%m', d[1]);
    format = format.replace('%d', d[2]);

    format = format.replace('%b', meses[parseInt(d[1])]);
    format = format.replace('%D', weekday[this.getDay()]);

    if (date[1]) {
        var d = date[1].split(':');
        format = format.replace('%H', d[0]);
        format = format.replace('%i', d[1]);
        format = format.replace('%s', d[2]);
    }

    return format;
};

String.prototype.calcAge = function() {
    var birthday = +new Date(this);
    return ~~((Date.now() - birthday) / 31557600000) + ' anos';
};

function to2ndBase(n) {
    n = parseInt(n);
    return n < 10 ? '0' + n : n;
}

function echo(t) {
    return t ? t.sanitize() : '';
}

String.prototype.sanitize = function() {
    return !this || 0 === this.length ? '' : this;
};

var meses = [
    null,
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
];

var weekday = new Array(7);
weekday[0] = 'Domingo';
weekday[1] = 'Segunda';
weekday[2] = 'Terça';
weekday[3] = 'Quarta';
weekday[4] = 'Quinta';
weekday[5] = 'Sexta';
weekday[6] = 'Sábado';

//button loading
(function($) {
    $.fn.buttonLoader = function(action) {
        var self = $(this);
        if (action == 'start') {
            if ($(self).attr('disabled') == 'disabled') {
                return false;
            }
            $(self).prop('disabled', true);
            $(self).attr('data-btn-text', $(self).html());

            var text = 'Aguarde';
            if (
                $(self).attr('data-load-text') != undefined &&
                $(self).attr('data-load-text') != '' &&
                $(self).attr('data-load-text') != 'null'
            ) {
                text = $(self).attr('data-load-text');
            } else if ($(self).attr('data-load-text') == 'null') {
                text = '';
            }

            $(self)
                .html(
                    '<span class="spinner"><i class="mdi mdi-loading mdi-spin" title="button-loader"></i></span> ' +
                        text
                )
                .button('refresh');
            $(self).addClass('active');
        } else if (action == 'stop') {
            $(self).html($(self).attr('data-btn-text'));
            $(self).removeClass('active');
            $(self).prop('disabled', false);
        }
    };
})(jQuery);

// Bootstrap 4 multi dropdown navbar
$(document).ready(function() {
    $('.dropdown-menu a.dropdown-toggle').on('click', function(e) {
        var $el = $(this);
        var $parent = $(this).offsetParent('.dropdown-menu');
        if (!$(this).next().hasClass('show')) {
            $(this).parents('.dropdown-menu').first().find('.show').removeClass('show');
        }
        var $subMenu = $(this).next('.dropdown-menu');
        $subMenu.toggleClass('show');

        $(this).parent('li').toggleClass('show');

        $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
            $('.dropdown-menu .show').removeClass('show');
        });

        if (!$parent.parent().hasClass('navbar-nav')) {
            $el.next().css({ top: $el[0].offsetTop, left: $parent.outerWidth() - 2 });
        }

        return false;
    });
});
